import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import {
  isExistAnyHistory,
  isExistHistory,
  isHiddenInPrint,
  itemTitleStyle,
} from '../../../../utils/helpers';
import DrugHistoryView from './history/drugHistoryView';
import FamilyView from './history/familyView';
import GynecologyView from './history/gynecology';
import InvestigationView from './history/investigationView';
import MedicalView from './history/medicalView';
import OthersView from './history/othersView';
import PediatricHistoryView from './history/PediatricHistoryView';
import PersonalView from './history/personalView';
import SurgicalView from './history/surgicalView';

const HistoryView = ({
  element,
  setShowHistory,
  selectedHistories,
  setSelectedHistories,
  isHistoryPage = false,
}) => {
  const userInfo = useSelector((state) => state.authReducer.data);
  const prescriptionItems = useSelector(
    (state) => state?.prescriptionReducer?.prescriptionInfo?.prescriptionItems,
  );

  const removeItemsData = (fieldName, delId) => {
    switch (fieldName) {
      case 'medicalNote':
        selectedHistories.medical.notes = '';
        break;
      case 'D_H':
      case 'D_A':
        selectedHistories.drugs[fieldName] = [];
        break;
      case 'personal':
        selectedHistories.personal = {
          smoker: false,
          alcoholic: false,
          tobacco: false,
          notes: '',
        };
        break;
      case 'family':
        selectedHistories.family = '';
        break;
      case 'medical':
        selectedHistories.medical = selectedHistories?.medical?.filter(
          (data) => data.name !== delId,
        );
        break;
      default:
    }
    setSelectedHistories({ ...selectedHistories });
  };

  return (
    <div
      className={`row item-row ${
        !isExistAnyHistory(selectedHistories)
          ? 'no-data-item-history d-block'
          : 'data-item-history d-block'
      }`}
      key={`history`}
    >
      <div
        className={`prescription-item history-item ${
          isHiddenInPrint(prescriptionItems, 'history') ? 'item-title-hide' : ''
        }`}
        style={itemTitleStyle(
          prescriptionItems?.items?.['history']?.titleStyle || {},
        )}
        {...(!isHistoryPage
          ? {
              onClick: (e) => {
                e.stopPropagation();
                setShowHistory(true);
              },
            }
          : {})}
      >
        {element?.alterName?.length ? (
          <span>{element?.alterName}</span>
        ) : (
          <span>History</span>
        )}
      </div>

      {selectedHistories && (
        <div className="history-view">
          {userInfo?.email === 'bnasrin.bsmmu@gmail.com' &&
            isExistHistory(selectedHistories, 'gynecology') && (
              <GynecologyView
                selectedHistories={selectedHistories}
                setSelectedHistories={setSelectedHistories}
                prescriptionItems={prescriptionItems}
              />
            )}
          {isExistHistory(selectedHistories, 'medical') && (
            <MedicalView
              selectedHistories={selectedHistories}
              setSelectedHistories={setSelectedHistories}
              prescriptionItems={prescriptionItems}
              isHistoryPage={isHistoryPage}
              isDelBtn="true"
              removeItemsData={removeItemsData}
            />
          )}
          {isExistHistory(selectedHistories, 'drugs') && (
            <DrugHistoryView
              selectedHistories={selectedHistories}
              setSelectedHistories={setSelectedHistories}
              prescriptionItems={prescriptionItems}
            />
          )}
          {isExistHistory(selectedHistories, 'investigations') && (
            <InvestigationView
              selectedHistories={selectedHistories}
              setSelectedHistories={setSelectedHistories}
              isHistoryPage={isHistoryPage}
              prescriptionItems={prescriptionItems}
            />
          )}
          {isExistHistory(selectedHistories, 'personal') && (
            <PersonalView
              selectedHistories={selectedHistories}
              setSelectedHistories={setSelectedHistories}
              isHistoryPage={isHistoryPage}
              removeItemsData={removeItemsData}
              prescriptionItems={prescriptionItems}
            />
          )}
          {isExistHistory(selectedHistories, 'pediatric') && (
            <PediatricHistoryView
              selectedHistories={selectedHistories}
              setSelectedHistories={setSelectedHistories}
              isHistoryPage={isHistoryPage}
              removeItemsData={removeItemsData}
              prescriptionItems={prescriptionItems}
            />
          )}
          {selectedHistories.family && (
            <FamilyView
              selectedHistories={selectedHistories}
              setSelectedHistories={setSelectedHistories}
              isHistoryPage={isHistoryPage}
              removeItemsData={removeItemsData}
              prescriptionItems={prescriptionItems}
            />
          )}
          {userInfo?.email !== 'bnasrin.bsmmu@gmail.com' &&
            isExistHistory(selectedHistories, 'gynecology') && (
              <GynecologyView
                selectedHistories={selectedHistories}
                setSelectedHistories={setSelectedHistories}
                prescriptionItems={prescriptionItems}
              />
            )}
          {isExistHistory(selectedHistories, 'surgical') && (
            <SurgicalView
              selectedHistories={selectedHistories}
              setSelectedHistories={setSelectedHistories}
              prescriptionItems={prescriptionItems}
            />
          )}
          {isExistHistory(selectedHistories, 'others') && (
            <OthersView
              selectedHistories={selectedHistories}
              setSelectedHistories={setSelectedHistories}
              prescriptionItems={prescriptionItems}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default memo(HistoryView);
